import { render, staticRenderFns } from "./DiagnosesList.vue?vue&type=template&id=0198ca14&scoped=true&"
import script from "./DiagnosesList.vue?vue&type=script&lang=js&"
export * from "./DiagnosesList.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosesList.vue?vue&type=style&index=0&id=0198ca14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198ca14",
  null
  
)

export default component.exports